// src/focusable/focusable-context.ts
import { createContext } from "react";
var FocusableContext = createContext(true);

export {
  FocusableContext
};
